import {defaultParams} from './state'

export function SET_SUMMARY_DATA(state, payload) {
    state.summaryData = Array.isArray(payload) ? payload : [];
}

export function SET_DETAIL_DATA(state, payload) {
    state.detailData = Array.isArray(payload) ? payload : [];
}

export function SET_LOADING(state, payload) {
    state.loading = !!payload;
}

export function SET_DETAIL_LOADING(state, payload) {
    state.detailLoading = !!payload;
}

export function SET_FILTERS(state, payload) {
    state.params = {
        ...state.filters,
        ...payload
    };
}

export function setSellerIdParams(state, seller_id) {
    state.params.sellerIds = seller_id;
}

export function setLeadershipIdParams(state, user_id) {
    if (user_id) {
        let leadership = state.leaderships.find(l => l.user_id === user_id);

        if (leadership) {
            state.params.leadershipIds = [leadership.id];
        }
    } else {
        state.params.leadershipIds = [];
    }
}

export function setSellersSelect(state, payload) {
    state.sellersSelect = payload;
}

export function setLeaderships(state, leaderships) {
    state.leaderships = leaderships;
}

export function resetParams(state) {
    state.params = defaultParams()
}

export function setCustomers(state, customers) {
    state.customers = customers;
}

export function setGroupedBrands(state, payload) {
    state.groupedBrands = payload;
}

export function setSegmentIdsToParams(state, segmentIds) {
    state.params.segmentIds = segmentIds;
}

export function setLoadedComponent(state, loadedComponent) {
    state.loadedComponent = loadedComponent;
}

export function setLines(state, lines) {
    state.lines = lines;
}

export function setFinalLines(state, finalLines) {
    state.finalLines = finalLines;
}

